import { render } from "./Coupon.vue?vue&type=template&id=31b74000&scoped=true"
import script from "./Coupon.vue?vue&type=script&lang=js"
export * from "./Coupon.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-31b74000"

export default script